<template>
  <button
    type="button"
    class="product-item__quick-shop-button--custom active btn btn--primary"
    :data-quick-add="product.handle"
    aria-expanded="false"
    aria-controls="cart-flyout-drawer"
  >
    <span>{{ quickShopText }}</span>
  </button>
</template>

<script>
  export default {
    props: {
      product: {
        type: Object,
        required: true,
      },
    },

    computed: {
      quickShopText() {
        return window.bvaccel.language.quick_shop_text;
      },
    },
  };
</script>

<style></style>
